import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top when route changes
    }, [location.pathname]);

    return <>{children}</>;
}

export default ScrollToTop;